<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableElasticacheResourceListData"
      style="width: 100.1%;"
    ></Table>
    <br />
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import ElastiCacheTableExpand from "../ElastiCacheTableExpand";
var tableElasticacheResourceMemcachedVue = {};
export default {
  name: "TableElasticacheResourceMemcached",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      companyId: "",
      accountName: "",
      columns: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(ElastiCacheTableExpand, {
              props: {
                row: params.row
              }
            });
          }
        },
        {
          title: this.$t("RAM.AWS.ElasticCache.accountID"),
          minWidth: 150,
          key: "accountIdStr"
        },
        {
          title: this.$t("RAM.AWS.ElasticCache.accountName"),
          minWidth: 150,
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.ElasticCache.region"),
          minWidth: 150,
          key: "region"
        },
        {
          title: this.$t("RAM.AWS.ElasticCache.clusterName"),
          minWidth: 150,
          key: "cacheClusterId"
        },

        {
          title: this.$t("RAM.AWS.ElasticCache.statusName"),
          minWidth: 150,
          key: "cacheClusterStatusName"
        },
        {
          title: this.$t("RAM.AWS.ElasticCache.createdTime"),
          minWidth: 150,
          key: "cacheClusterCreateTimeStr"
        },

        {
          title: this.$t("RAM.AWS.ElasticCache.primaryEndpoint"),
          minWidth: 150,
          key: "primaryEndpoint"
        },
        {
          title: this.$t("RAM.AWS.ElasticCache.configurationEndpoint"),
          minWidth: 150,
          key: "configurationEndpoint"
        },
        {
          title: this.$t("RAM.AWS.ElasticCache.engine"),
          minWidth: 150,
          key: "cacheEngineName"
        },
        {
          title: this.$t("RAM.AWS.ElasticCache.nodeType"),
          minWidth: 150,
          key: "cacheNodeType"
        },
        {
          title: this.$t("RAM.AWS.ElasticCache.securityGroups"),
          minWidth: 150,
          key: "securityGroups"
        },
        {
          title: this.$t("RAM.AWS.ElasticCache.multiAz"),
          minWidth: 150,
          fixed: "right",
          key: "multiAz"
        }
      ],
      tableElasticacheResourceListData: []
    };
  },
  beforeCreate: function() {
    tableElasticacheResourceMemcachedVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("companyId", function(companyId) {
      tableElasticacheResourceMemcachedVue.companyId = companyId;
    });
    eventBus.$on("accountName", function(accountName) {
      tableElasticacheResourceMemcachedVue.accountName = accountName;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableElasticacheResourceMemcachedVue.getElasticacheMemcachedResourceListData();
    },
    // 分页显示数据
    /****************************************************/
    getElasticacheMemcachedResourceListData: function() {
      // 情况Table中之前的数据
      this.tableElasticacheResourceListData = [];

      this.$api.resourceManagement
        .selectAwsElastiCacheByPage({
          pageNum: this.current,
          pageSize: this.pageSize,
          cacheEngine: 0,
          companyId: tableElasticacheResourceMemcachedVue.companyId,
          accountName: tableElasticacheResourceMemcachedVue.accountName
        })
        .then(res => {
          this.tableElasticacheResourceListData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableElasticacheResourceMemcachedVue.getElasticacheMemcachedResourceListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableElasticacheResourceMemcachedVue.getElasticacheMemcachedResourceListData();
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/elasticache/memcached/TableElastiCacheResourceMemcached.vue